import React, { useEffect, useRef } from "react"
import ReactDOM from "react-dom"

export const getAnchors = () =>{
  let gAnchors = document.getElementsByTagName('a');
  Array.from(gAnchors).map((value,index)=>{
   // let anchor_val = value.name;
  //  ReactDOM.render(
  //     // <setNewAnchor name="{}"></setNewAnchor>
  //  );
    ////console.log(anchor_val)
  }
 
  )

   
  
}
let setNewAnchor = ({name})=>{
    return (
        <a name={name}></a>
      )
}